import { SBox } from '@avalara/skylab-sdk/react';
import type { Address } from '../../../../../types';

type InvalidAddressConfirmationPros = {
  userEnteredAddress: Address;
};

const InvalidAddressConfirmation = ({ userEnteredAddress }: InvalidAddressConfirmationPros) => {
  const addressFirstLine = `${userEnteredAddress?.line1}, ${userEnteredAddress?.line2}`;
  const addressSecondLine = `${userEnteredAddress?.city}, ${userEnteredAddress?.region}, ${userEnteredAddress.postalCode}, ${userEnteredAddress?.country}`;
  const confirmationTitle = 'Check the address';
  const userAddressLabel = 'Address as entered';
  const confirmationSubtitle =
    'There isn’t an exact match for the address as entered. Make sure it’s correct before continuing.';
  return (
    <>
      <div slot='header' id='address-validation-dialog-title' data-ref='buy.address-validation.invalid-address.header'>
        {confirmationTitle}
      </div>
      <div slot='body' data-ref='buy.address-validation.invalid-address.body'>
        <p>{confirmationSubtitle}</p>
        <SBox className='pad-all-sm invalid-address' data-ref='buy.address-validation.invalid-address.warning-box'>
          <span
            className='text-sm font-semibold flex margin-bottom-sm'
            data-ref='buy.address-validation.invalid-address.warning-label'
          >
            {userAddressLabel}
          </span>
          <div>
            <p>{addressFirstLine}</p>
            <p>{addressSecondLine}</p>
          </div>
        </SBox>
      </div>
    </>
  );
};

export default InvalidAddressConfirmation;
